import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {a11yPriceId} from '../../a11y'
import {Labeled} from '../labeled'
import {classes} from './price.st.css'

export const Price = ({
  label,
  id,
  price,
  extraAriaLabeledBy = '',
}: {
  label: string
  id: string
  price: string
  extraAriaLabeledBy?: string
}) => {
  const priceId = a11yPriceId(id)

  return (
    <Labeled label={label} labeledElementId={priceId}>
      {({ariaLabeledBy}) => (
        <Text
          tagName="p"
          role="group"
          id={priceId}
          className={classes.price}
          data-hook={DH.PRICE}
          aria-labelledby={`${extraAriaLabeledBy} ${ariaLabeledBy}`}
        >
          {price}
        </Text>
      )}
    </Labeled>
  )
}
